import axios, { type AxiosRequestConfig } from 'axios';

// server(RSC, MSW Node 등)에선 absolute URL이 필요해 NEXT_PUBLIC_BOOTCAMP_APPLY_API_URL을 그대로 사용.
// browser에선 same-origin '/'로 두어 next.js rewrites가 BE로 proxy하게 한다 (CORS 우회).
// rewrites는 apps/apply-frontend/next.config.ts에서 환경 무관(dev/test/prod) 적용.
const isServer = typeof window === 'undefined';
const apiClient = axios.create({
  baseURL: isServer ? (process.env.NEXT_PUBLIC_BOOTCAMP_APPLY_API_URL ?? '/') : '/',
  withCredentials: true,
  // 배열 쿼리 파라미터는 브래킷 없는 반복 형식으로 직렬화 (a=1&a=2).
  // axios 기본값(a[]=1&a[]=2)은 NestJS ValidationPipe가 422로 거절한다 (예: 리드 목록 engagements).
  paramsSerializer: { indexes: null },
});

export const setApiBaseUrl = (baseURL: string): void => {
  apiClient.defaults.baseURL = baseURL;
};

export const getApiClient = () => apiClient;

// 401 정책은 앱마다 다르다 (apply: /login redirect, backoffice: OAuth 재인증 등).
// 인증 방식을 mutator가 알 필요 없이, 401이 왔다는 사실만 알리고 처리는 각 앱이 등록한 핸들러에 위임.
let onUnauthorized: (() => void) | null = null;
export const setOnUnauthorized = (handler: (() => void) | null): void => {
  onUnauthorized = handler;
};

// module top-level에서 등록 — singleton이 만들어지는 시점에 wire되어야 첫 요청부터 가로챈다.
// useEffect 안에서 등록하면 mount 직후 발사되는 React Query 첫 요청을 놓친다.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      onUnauthorized?.();
    }
    return Promise.reject(error);
  },
);

export const customInstance = async <T>(config: AxiosRequestConfig): Promise<T> => {
  const { data } = await apiClient.request<T>(config);
  return data;
};

export type ErrorType<E> = E;
export type BodyType<BodyData> = BodyData;
